module.exports = __webpack_public_path__ + "img/trikot_aXz.391d1660.png";